import React, { useEffect, useState } from 'react';
import ConsultBanner from '../../components/ConsultBaneer';
import ConsultCard from '../../components/ConsultCard';
import { getSeoByUrl } from '../../api/api';

const Consult = () => {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("consult"); 
        
        if (response.success && response.data) {
          setSeoData(response.data);
          updateMetaTags(response.data);
          console.log("Consult page SEO loaded:", response.data.metaTitle);
        } else {
          console.log("No SEO data found, using default SEO for Consult page");
          const defaultSeo = {
            metaTitle: "Consult DNA Based Nutritionists - Personalized Diet Plans | Nutrillion",
            metaDescription: "Consult expert DNA-based nutritionists at Nutrillion for personalized diet plans, genetic testing, and customized wellness solutions tailored to your unique DNA.",
            robotsTxt: "index, follow",
            canonicalUrl: "https://nutrillion.one/consult",
            metaKeywords: "consult nutritionist, DNA based diet, personalized nutrition, genetic testing, wellness consultation"
          };
          updateMetaTags(defaultSeo);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeoData();
  }, []);

  const updateMetaTags = (data) => {
    // Update title
    if (data.metaTitle) document.title = data.metaTitle;
    
    // Update or create meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (data.metaDescription) metaDesc.setAttribute('content', data.metaDescription);
    
    // Update keywords if exists
    if (data.metaKeywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', data.metaKeywords);
    }
    
    // Update robots
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    if (data.robotsTxt) robotsMeta.setAttribute('content', data.robotsTxt);
    
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    if (data.canonicalUrl) canonicalLink.setAttribute('href', data.canonicalUrl);
    
    // Add schema markup if exists
    if (data.schemaMarkup) {
      let existingScript = document.querySelector('#schema-markup');
      if (existingScript) existingScript.remove();
      
      const script = document.createElement('script');
      script.id = 'schema-markup';
      script.type = 'application/ld+json';
      script.textContent = data.schemaMarkup;
      document.head.appendChild(script);
    }
  };

  return (
    <div>
      <ConsultBanner />
      <ConsultCard />
    </div>
  );
};

export default Consult;